import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getStorage } from "firebase/storage";

// Jouw web app's Firebase configuratie
// Let op: Deze waarden zijn gevoelig en horen in een .env bestand.
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialiseer Firebase
const app = initializeApp(firebaseConfig);

// Exporteer de services die je wilt gebruiken in je app
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'europe-west3');
export const storage = getStorage(app);

// Verbind met de emulators alleen in de ontwikkelomgeving
// if (process.env.NODE_ENV === 'development') {
//     console.log("Connecting to Firebase emulators...");
//     connectAuthEmulator(auth, 'http://localhost:9099');
//     connectFirestoreEmulator(db, 'localhost', 8080);
//     connectFunctionsEmulator(functions, 'localhost', 3001);
// }